module.exports = __webpack_public_path__ + "static/11-bf459c9c03d08cb1d3121148ffc0806a.jpeg";